module.exports = __webpack_public_path__ + "media/common/images/badges/active/super_pruvodce-e8c2b29c15fcfa2daf8b57f527d96b3b.svg";